module.exports = __webpack_public_path__ + "img/swirl.1fa011e3.svg";